var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00112 3.6C8.38113 3.6 7.78654 3.85286 7.34814 4.30294C6.90974 4.75303 6.66345 5.36348 6.66345 6C6.66345 6.63652 6.90974 7.24697 7.34814 7.69706C7.78654 8.14714 8.38113 8.4 9.00112 8.4C9.6211 8.4 10.2157 8.14714 10.6541 7.69706C11.0925 7.24697 11.3388 6.63652 11.3388 6C11.3388 5.36348 11.0925 4.75303 10.6541 4.30294C10.2157 3.85286 9.6211 3.6 9.00112 3.6ZM9.00112 10C7.9678 10 6.97682 9.57857 6.24615 8.82843C5.51549 8.07828 5.10501 7.06087 5.10501 6C5.10501 4.93913 5.51549 3.92172 6.24615 3.17157C6.97682 2.42143 7.9678 2 9.00112 2C10.0344 2 11.0254 2.42143 11.7561 3.17157C12.4867 3.92172 12.8972 4.93913 12.8972 6C12.8972 7.06087 12.4867 8.07828 11.7561 8.82843C11.0254 9.57857 10.0344 10 9.00112 10ZM9.00112 0C5.10501 0 1.77774 2.488 0.429688 6C1.77774 9.512 5.10501 12 9.00112 12C12.8972 12 16.2245 9.512 17.5725 6C16.2245 2.488 12.8972 0 9.00112 0Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye_Icon.48762addd1417c9d890d2eb9d75f9f0f.svg";